import Api from './rest/SpecHistoryApi';

export default new Api();
